import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getAllLottery } from "./lotteryReducer";

export const authenticationReducer = createSlice({
  name: "authentication",
  initialState: {
    token: null,
    key: null,
    data: null
  },
  reducers: {
    setAuthenticationToken: (state, { payload }) => {
      localStorage.setItem("Token", payload);
      // localStorage.setItem("Key", payload.key);
      state.token = payload;
      // state.key = payload.key;
    },
    setAuthenticationKey: (state, { payload }) => {
      // localStorage.setItem("Token", payload.token);
      localStorage.setItem("Key", payload.key);
      // state.token = payload.token;
      state.key = payload.key;
    },
  },
});

export const { setAuthenticationToken, setAuthenticationKey,setData } =
  authenticationReducer.actions;
export default authenticationReducer.reducer;

const loginAuthen = (token) => async (dispatch) => {
  const header2 = {
    headers: {
      accept: "application/json; charset=UTF-8",
      "content-type": "text/plain",
      authorization: "Bearer " + token,
    },
  };

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_OPERATOR}/api/memberMgmt/cusSite/checkAuthen`,
      header2
    );
    if (res.data.code == "999999") {
      dispatch(setAuthenticationToken(token));
      dispatch(setAuthenticationKey(res.data.data));
      localStorage.setItem("username", res.data.data.username)
      localStorage.setItem("redirect", res.data.data.optUrl)
      await dispatch(getAllLottery(res.data.data));
      return res.data.code;
    }
  } catch (err) {
    console.error(err);
  }
};

export { loginAuthen };
